module.exports = __webpack_public_path__ + "img/empty-quest.5b2a9c12.svg";